import * as types from './types';
import * as merge from '../../../helpers/object/merge';

const defaultConfig = {
  trigger_button: {
    style: {
      backgroundColor: '#44B3F2',
      color: '#fff',
      borderRadius: '5px',
      width: '250px',
    },
    kind: 'basic',
    text: 'Responda nossa pesquisa',
  },
  progressbar: {
    kind: 'standard',
    svg: {
      bullet: '<svg></svg>',
      bar: '<svg></svg>',
    },
    step: 0,
  },
  advanced: {
    view_mode: 'click',
    exibition_mode: 'immediately',
    exibition_mode_time_value: 5,
    exibition_mode_scroll_value: 50,
    exibition_frequency: 'until_action',
    exibition_frequency_times_value: 3,
    exibition_frequency_interval_value: 3,
  },
};

export const state = {
  list: [],
  active: {
    config: defaultConfig,
  },
  showKlickpagesHeader: true,
};

const find = (state, data, callback) => state.list.map((box, index) => {
  if (box.id === data.id) {
    callback(box, index);
  }

  return box;
});

export const mutations = {
  [types.BOX_ACTIVE_SET](state, box) {
    box.config = merge.deep({}, defaultConfig, box.config);

    state.active = box;
  },
  [types.BOX_LIST_SET](state, boxes) {
    state.list = boxes;
  },
  [types.BOX_ACTIVE_UPDATE_KIND](state, type) {
    state.active.kind = type;
  },
  [types.BOX_ACTIVE_UPDATE_FORMAT](state, format) {
    state.active.format = format;
  },
  [types.BOX_ACTIVE_UPDATE_THEME_SLUG](state, data) {
    state.active.theme_slug = data.theme_slug;
  },
  [types.BOX_ACTIVE_UPDATE_THEME_FONTS](state, data) {
    state.active.theme_fonts = data.theme_fonts;
  },
  [types.BOX_ACTIVE_UPDATE_NAME](state, name) {
    state.active.name = name;
  },
  [types.BOX_LIST_UPDATE_NAME](state, data) {
    find(state, data, (box) => {
      box.name = data.name;
    });
  },
  [types.BOX_LIST_REMOVE](state, data) {
    find(state, data, (box, index) => {
      state.list.splice(index, 1);
    });
  },
  [types.BOX_ACTIVE_RESET](state) {
    state.active = {
      config: defaultConfig,
    };
  },
  [types.BOX_SET_CONFIG](state, config) {
    state.active.config = config;
  },
  [types.BOX_UPDATE_CONFIG](state, { item, key, value }) {
    state.active.config[item][key] = value;
  },
  [types.BOX_UPDATE_CONFIG_STYLE](state, { item, rule, value }) {
    state.active.config[item].style[rule] = value;
  },
  [types.BOX_UPDATE_CONTENT_BODY](state, contentBody) {
    state.active.content_body = contentBody;
  },
  [types.KLICKPAGES_HEADER_ACTIVE](state, data) {
    state.showKlickpagesHeader = data;
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/box/mutations.js
 **/